import { Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { NotesService } from './notes.service';
import { FormControl, FormGroup } from '@angular/forms';

import { AppService } from '../../../app.service';
import { ConfirmService } from '../../confirm/confirm.service';
import { ActivatedRoute } from '@angular/router';
import { Globals } from '../../../globals';
import { NgxSmartModalService } from 'ngx-smart-modal';
import translateJson from "../../../../translate.json";
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'notes-comp',
    providers: [NotesService, AppService, ConfirmService, NgxSmartModalService, ConfirmService],
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.css']
})

export class NotesComponent {
    @Input() id: String;
    @Input() entity: String;
    @Input() notes: Object;
    @Input() archived: Boolean;
    @Output() nrOfNotesEmitter = new EventEmitter<any>();
    @Output() errorComponent = new EventEmitter<any>();


    // Get translation/text from customerJson
    private i18 = translateJson.i18;

    type: String;
    notesForm: FormGroup;
    notesUpdateForm: FormGroup;
    showLoader: Boolean = false;
    showNoteEditor: Boolean = false;
    showNotesDetailsActive = true;
    isArchived: Boolean = false;
    editingNote: any = [];
    showNoteUpdateEditor: boolean = false;
    activeNoteId: String = "";
    

    constructor(
        private service: NotesService,
        private appService: AppService,
        private ngxSmartModalService: NgxSmartModalService,
        private activatedRoute: ActivatedRoute,
        private globals: Globals,
        private confirmService: ConfirmService,
        @Inject(DOCUMENT) private document: Document
        ) {
        activatedRoute.params.subscribe(val => {
            this.type = this.activatedRoute.snapshot.paramMap.get('type');
            this.setDefault();
        })
    }

    /**
     * Initiates the notes form
     */
    setDefault() {        
        this.notesForm = new FormGroup({
            id: new FormControl(),
            notes: new FormControl()
        });
        this.notesUpdateForm = new FormGroup({
            id: new FormControl(),
            noteUpdate: new FormControl(),
        });
    }

    /**
     * Set the route to a new desired route
     * @param route
     */
    setRoute(route) {
        this.appService.setRoute(route);
    }

    /**
     * Show or hide notes dropdown
     */
    showNotesDetails() {
        this.showNotesDetailsActive = !this.showNotesDetailsActive;
    }

    /**
     * Display notes
     */
    displayNotes(data) {
        this.notes = data;
        if(this.activeNoteId != ""){
            this.enableIcons();
        }
        this.nrOfNotesEmitter.emit(data.length);
        
       // this.appService.setRoute(this.entity +'/view/'+ this.id);
    }

    /**
     * Show error (emits the error message to parent)
     * @param error error text
     */
    showError(error) {
        this.errorComponent.emit(error);
        this.showLoader = false;
    }

    /**
     * Active textarea/editor for notes
     */
    activateNoteEditor() {
        this.showNoteEditor = !this.showNoteEditor;
    }

    /**
     * Save notes
     * @param notesForm data from notes
     */
    saveNotes(notesForm) {
        this.showNoteEditor = false;
        this.notesForm.patchValue({notes: null});
        this.service.saveNotes(this.id, this.entity, notesForm)
        .subscribe(
            data => this.displayNotes(data),
            error => this.showError(error.error)
        );
    }

    /**
     * Delete notes
     */
    deleteNoteModal(note) {
        this.ngxSmartModalService.setModalData(note, 'warningModal', true);
        this.ngxSmartModalService.getModal('warningModal').open();
    }

    deleteNote(noteId) {
        this.service.deleteNotes(this.id, this.entity, noteId)
        .subscribe(
            data => this.displayNotes(data),
            error => this.showError(error.error)
        );
    }
    /**
     * Helper to remove the disabled property for a textarea by its id
     * @param noteId html id of note
     */
    enableNoteUpdate(noteId) {
        if (this.document.getElementById("note-"+noteId).getAttribute("disabled") === '') {
            this.document.getElementById("note-"+noteId).removeAttribute("disabled");
            this.document.getElementById("note-"+noteId).style.border ="1px solid lightgrey";
            this.document.getElementById("note-"+noteId).style.borderRadius ="2px";
            this.document.getElementById("note-"+noteId).focus();
            this.showNoteUpdateEditor = true;
            this.activeNoteId = noteId;
            this.disableIcons()
        }
    }

    /**
     * Helper to set the disabled property for a textarea by its id
     * @param noteId html id of note
     */
    abortNoteUpdate(noteId) {
        if(this.document.getElementById("note-"+noteId).getAttribute("disabled") == null) {
            this.document.getElementById("note-"+noteId).setAttribute("disabled", "");
            this.document.getElementById("note-"+noteId).style.border ="0px solid lightgrey";
            this.document.getElementById("note-"+noteId).style.borderRadius ="0px";
            this.document.getElementById("note-"+noteId).blur();
            this.showNoteUpdateEditor = false;
            this.activeNoteId = "";
            this.enableIcons();
        }
    }
    disableIcons(){
        for(let i = 0; i< Object.keys(this.notes).length; i++){
            this.document.getElementById("note-trash-"+i).style.pointerEvents = "none";
            this.document.getElementById("note-trash-"+i).style.color = "grey";
            this.document.getElementById("note-edit-"+i).style.pointerEvents = "none";
            this.document.getElementById("note-edit-"+i).style.color = "grey";
        } 
    }
    enableIcons(){
        for(let i = 0; i< Object.keys(this.notes).length; i++){
            this.document.getElementById("note-trash-"+i).style.pointerEvents = "auto";
            this.document.getElementById("note-trash-"+i).style.color = "black";
            this.document.getElementById("note-edit-"+i).style.pointerEvents = "auto";
            this.document.getElementById("note-edit-"+i).style.color = "black";
        }
        this.activeNoteId = ""; 
    }

    /**
     * function to get the new note value and perform a update request
     * @param noteId 
     * @param noteObj 
     */
    noteUpdate(noteId, noteObj){
        let newNote = (<HTMLInputElement>this.document.getElementById("note-"+noteId)).value;
        let updatedNote = {
            id: noteObj.id,
            notes: newNote
        }
        this.service.updateNotes(this.id, this.entity, noteObj.id, updatedNote).subscribe(
            data => {
                this.displayNotes(data);
                this.showNoteUpdateEditor = false;
            },
            error => this.showError(error)
        )

    }

    /**
     * Notes configuration
     */
    public options: Object = {
        charCounterCount: true,
        height: 200,
        quickInsertTags: [''],
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'formatOL', 'formatUL'],
        toolbarButtonsXS: ['bold', 'italic', 'underline', '|', 'formatOL', 'formatUL'],
        toolbarButtonsSM: ['bold', 'italic', 'underline', '|', 'formatOL', 'formatUL'],
        toolbarButtonsMD: ['bold', 'italic', 'underline', '|', 'formatOL', 'formatUL'],
      };
}